import { Box } from "@mui/material";
import  { useState } from "react";
import { Navigate } from "react-router-dom";
import WarehouseManagementMenu from "../features/warehouse/WarehouseMenu";
import WarehouseIndex from "../features/warehouse/WarehouseList";

const WarehouseManagement = () => {
    const [activePage, setActivePage] = useState('ViewMainPage');

    const SetActive = (page) => {
        setActivePage(page);
    }

    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }
    return (
        <Box position="relative">
            {activePage === "ViewMainPage" && (<WarehouseManagementMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />)}
            {/* 1.Paper  Machine Production Entry */}
            {activePage === "Warehouse" && (
                <WarehouseIndex handleBackWinderMachineEntry={handleBackWinderMachineEntry} reelID={0} />
            )}
            {/* <AddWarehouseDetails/> */}
            {/* <WarehouseForm/> */}
            {/* <ReelCalculator/> */}
            {/* <AllocateLocationForReel /> */}
            
        </Box>

    );

};
export default WarehouseManagement;